import { HOST, SERVICES_BASE_URL, AUTHORIZATION_SERVICE_URL, LANG, COUNTRY_CODE, USER_ID, BUSINESS_LANDING, IS_PRICE_LIST_APPROVAL } from "./constants";
import  AppConfigData from './app-config.json';
import { createFormAndSubmit, getUrlParameterByName, escapeHtml } from "../utils/utility";

export const redirectForAuthentication = (type, newOrderData, tokenId) => {
    const authenticationType = (type && (typeof type === "string")) ? type : "login";
    const redirectUrl = SERVICES_BASE_URL + AUTHORIZATION_SERVICE_URL + AppConfigData.redirect_urls[authenticationType];
    const params = {
        languageCode: LANG,
        countryCode: COUNTRY_CODE,
        ...(newOrderData) && {
            newOrderData: escapeHtml(JSON.stringify(newOrderData))
        },
        ...(tokenId) && {
            id: tokenId
        },
        // ...(!BUSINESS_LANDING) && {
        //     landing: "consumer"
        // },
        ...(IS_PRICE_LIST_APPROVAL) && {
            priceListUploadId: JSON.parse(atob(getUrlParameterByName("data"))).priceListUploadId || null
        }
    };

    // Register analytic tracking event - start
    window.dataLayer.push({
        event: 'e_formSubmit',
        formName: authenticationType
    });
    // Register analytic tracking event - end

    createFormAndSubmit("POST", "_self", redirectUrl, params);
}

export const redirectForSignOut = () => {
    const signoutUrl = SERVICES_BASE_URL + AUTHORIZATION_SERVICE_URL + AppConfigData.redirect_urls.signout;
    let postSignoutRedirectionUrl = HOST + window.location.pathname + "?languageCode=" + LANG + "&countryCode=" + COUNTRY_CODE;

    if (!BUSINESS_LANDING) postSignoutRedirectionUrl += "&landing=consumer";

    const params = {
        state: btoa(postSignoutRedirectionUrl),
        id: USER_ID
    };

    window.dataLayer.push({
        event: 'e_formSubmit',
        formName: "logout"
    });

    createFormAndSubmit("GET", "_self", signoutUrl, params);
}

export const redirectForResetPassword = (userId, tokenId) => {
    const resetPasswordUrl = SERVICES_BASE_URL + AUTHORIZATION_SERVICE_URL + AppConfigData.redirect_urls.resetPassword + "/" + userId;

    const params = {
        languageCode: LANG,
        countryCode: COUNTRY_CODE,
        ...(tokenId) && {
            id: tokenId
        }
    };

    // Register analytic tracking event - start
    window.dataLayer.push({
        event: 'e_formSubmit',
        formName: "resetPassword"
    });
    // Register analytic tracking event - end

    createFormAndSubmit("POST", "_self", resetPasswordUrl, params);
}